export const loadState = () => {
  try {
    const serialisedSate = sessionStorage.getItem('state');
    if (serialisedSate === null) {
      return undefined;
    }
    const state = JSON.parse(serialisedSate);
    if (!state.isStatePersisted) {
      return undefined;
    }
    return { consultationReducer: state.consultationReducer, flagsReducer: state.flagsReducer };
  } catch (error) {
    // todo: This should be throwing an error that is handled by an Error Boundary that surrounds the app
    return undefined;
  }
};

export const saveState = state => {
  try {
    const consultationStateToBeSaved = state.flagsReducer.isStatePersisted ? state.consultationReducer : {};
    const serialisedSate = JSON.stringify({
      consultationReducer: consultationStateToBeSaved,
      isStatePersisted: state.flagsReducer.isStatePersisted,
      flagsReducer: { showSessionExpiryValidationOnLoad: state.flagsReducer.showSessionExpiryValidationOnLoad },
    });
    sessionStorage.setItem('state', serialisedSate);
  } catch (error) {
    // todo: This should be throwing an error that is handled by an Error Boundary that surrounds the app
    // eslint-disable-next-line
    console.error(error);
  }
};

// We're using local storage instead of cookies as they'll only be used by the frontend.
export const loadLocalStorage = () => {
  try {
    const serialisedState = localStorage.getItem('state');
    if (serialisedState === null) {
      return {};
    }
    return JSON.parse(serialisedState);
  } catch (error) {
    return {};
  }
};

export const saveLocalStorage = preferences => {
  try {
    const serialisedPreferences = JSON.stringify(preferences);
    localStorage.setItem('state', serialisedPreferences);
  } catch (error) {
    // todo: This should be throwing an error that is handled by an Error Boundary that surrounds the app
    // eslint-disable-next-line
    console.error(error);
  }
};
